import React, { useContext } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { observer } from 'mobx-react';
import { styled } from '@mui/system';
import { BrowserRouter } from 'react-router-dom';
import { ConfirmProvider } from 'material-ui-confirm';
import { SnackbarProvider } from 'material-ui-snackbar-provider';
import { ThemeContext } from './util/ThemeStore';
import Footer from './Components/Footer';
import Router from './Components/Router';

const Body = styled('div')({
  height: '100%',
  minHeight: window.self !== window.top ? undefined : '100vh',
  display: 'flex',
  flexDirection: 'column',
  marginTop: 32,
});

const App = observer(() => {
  const themeStore = useContext(ThemeContext);

  const theme = createTheme({
    cssVariables: true,
    palette: {
      white: { main: '#FFFFFF' },
    },
    typography: {
      ...themeStore.typography,
      // fontFamily: '"Trebuchet MS", "Georgia", "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Tahoma, sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <ConfirmProvider>
        <SnackbarProvider SnackbarProps={{ autoHideDuration: 4000 }}>
          <Body>
            <BrowserRouter>
              <Router />
            </BrowserRouter>
            <Footer />
          </Body>
        </SnackbarProvider>
      </ConfirmProvider>
    </ThemeProvider>
  );
});

export default App;
